import { ProductForm } from '../../../typings/products';

export const UPDATE_INTERNAL_PRODUCTS_FORM = 'UPDATE_INTERNAL_PRODUCTS_FORM';
export type UPDATE_INTERNAL_PRODUCTS_FORM = typeof UPDATE_INTERNAL_PRODUCTS_FORM;

export interface UpdateInternalProductsForm {
    type: UPDATE_INTERNAL_PRODUCTS_FORM;
    form: ProductForm;
}

export function updateInternalProductsFormAction(form: ProductForm): UpdateInternalProductsForm {
    return {
        type: UPDATE_INTERNAL_PRODUCTS_FORM,
        form
    };
}
